import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { BehaviorSubject, combineLatest, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { KpiAnalyticsScheduleModel } from '../../../services-api-v2/kpi-follow-up/models/kpi-analytics-schedule.model';
import { ParkPlanningAnalyticsScheduleService } from '../../../services-api-v2/kpi-follow-up/park/planning-analytics/park-planning-analytics-schedule/park-planning-analytics-schedule.service';

@Component({
    selector: 'app-kpi-planning-analytics-schedule-chart',
    templateUrl: './kpi-planning-analytics-schedule-chart.component.html',
    styleUrls: ['./kpi-planning-analytics-schedule-chart.component.scss'],
    standalone: false
})
export class KpiPlanningAnalyticsScheduleChartComponent implements OnInit, OnChanges, OnDestroy {

  @Input() assetsIds: string[];
  @Input() subAssetsIds: string[];
  @Input() endRange: number;
  @Input() startRange: number;
  @Input() category: string[];
  @Input() queryService: ParkPlanningAnalyticsScheduleService;

  public scheduleData: BehaviorSubject<KpiAnalyticsScheduleModel> = new BehaviorSubject<KpiAnalyticsScheduleModel>(null);
  public endRange$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  public startRange$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  private assetsIds$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(null);
  private subAssetsIds$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(null);
  private category$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(null);
  private unsubscriber = new ReplaySubject();

  ngOnInit() {
    this.getData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.assetsIds) {
      this.assetsIds$.next(changes.assetsIds.currentValue);
    }
    if (changes && changes.endRange) {
      this.endRange$.next(changes.endRange.currentValue);
    }
    if (changes && changes.startRange) {
      this.startRange$.next(changes.startRange.currentValue);
    }
    if (changes && changes.category) {
      this.category$.next(changes.category.currentValue);
    }
    if (changes && changes.subAssetsIds) {
      this.subAssetsIds$.next(changes.subAssetsIds.currentValue);
    }
  }

  ngOnDestroy() {
    this.unsubscriber.next(true);
    this.unsubscriber.complete();
  }

  private getData(): void {
    if (this.queryService) {
      combineLatest([
        this.assetsIds$,
        this.startRange$,
        this.endRange$,
        this.category$,
        this.subAssetsIds$
      ]).pipe(
        takeUntil(this.unsubscriber),
        distinctUntilChanged((a: any, b: any) => JSON.stringify(a) === JSON.stringify(b)),
        tap(() => this.scheduleData.next(null)),
        filter(([assetsIds, startRange, endRange, category]) =>
          !!assetsIds && !!startRange && !!endRange && !!category
        ),
        switchMap(([assetsIds, startRange, endRange, category, subAssetsIds]) => {
          return this.queryService.getSchedule(assetsIds, startRange, endRange, category, subAssetsIds)
        }
        )
      ).subscribe((data: KpiAnalyticsScheduleModel) => {
        this.scheduleData.next(data);
      });
    }
  }

}
